<template>
  <form-container>
    <template v-slot:content>
      <h3 class="mb-5 black--text title text-uppercase font-weight-black">Sign In to Aliha</h3>
      <div>
        <v-btn depressed x-large color="deep-orange darken-1" dark block class="mb-2"
          @click="tryLoginWithGoogle"
          :class="{'disabled': authenticating}">
          SignIn with Google
          <v-icon right dark>mdi-google</v-icon>
        </v-btn>
        <v-btn depressed x-large color="grey darken-4" dark block
          @click="tryLoginWithGithub"
          :class="{'disabled': authenticating}">
          SignIn with Github
          <v-icon right dark>mdi-github-circle</v-icon>
        </v-btn>
      </div>

    <div class="overline my-6">or</div>
      <login-form></login-form>
    </template>
  </form-container>
</template>

<script>
import { mapActions } from 'vuex';
import types from '@/store/types';

import FormContainer from '@/components/FormContainer.vue';
import LoginForm from '@/components/LoginForm.vue';

export default {
  name: 'login-page',
  data: () => ({
    authenticating: false,
  }),
  components: {
    FormContainer,
    LoginForm,
  },
  methods: {
    ...mapActions('auth', {
      loginWithGoogle: types.LOGIN_WITH_GOOGLE,
      loginWithGithub: types.LOGIN_WITH_GITHUB,
    }),
    tryLoginWithGoogle() {
      this.authenticating = true;
      this.loginWithGoogle().then(() => {
        this.$router.replace(this.$store.state.routes.DASHBOARD.to);
      }).catch(() => {}).finally(() => {
        this.authenticating = false;
      });
    },
    tryLoginWithGithub() {
      this.authenticating = true;
      this.loginWithGithub().then(() => {
        this.$router.replace(this.$store.state.routes.DASHBOARD.to);
      }).catch(() => {}).finally(() => {
        this.authenticating = false;
      });
    },
  },
};
</script>
